module.exports = __webpack_public_path__ + "img/Excavation POI Icon_selected.15a7ff53.svg";